import axios from 'axios';
import { webAPIs } from "./webAPIs";
import { env } from "./env";

const CSRF_HEADER = 'X-CSRF-Token';
const CSRF_COOKIE = 'csrf_token';
const unsafeMethods = new Set(['post', 'put', 'patch', 'delete']);

const getCookie = (name) => {
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`)
  );
  return match ? decodeURIComponent(match[1]) : null;
};

const axiosInstance = axios.create({
  baseURL: env.REACT_APP_SERVER_URL,
  withCredentials: true,
});

let refreshPromise = null;

axiosInstance.interceptors.request.use(
  (config) => {
    config.withCredentials = true;
    const method = config.method ? config.method.toLowerCase() : '';
    if (unsafeMethods.has(method)) {
      const csrfToken = getCookie(CSRF_COOKIE);
      if (csrfToken) {
        config.headers = {
          ...config.headers,
          [CSRF_HEADER]: csrfToken,
        };
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const {response, config} = error;

      if (!response) {
        return Promise.reject(error);
      }

      const skipRefresh = [
        webAPIs.signIn,
        webAPIs.signUp,
        webAPIs.forgetPassword,
        webAPIs.resetPasswordConfirmation,
        webAPIs.refreshToken,
      ].includes(config.url);

      if (response.status === 401 && skipRefresh) {
        return Promise.reject(error);
      }

      if (response.status === 401 && !config._retry) {
        config._retry = true;
        try {
          if (!refreshPromise) {
            const csrfToken = getCookie(CSRF_COOKIE);
            refreshPromise = axios.post(
                webAPIs.refreshToken,
                {},
                {
                  withCredentials: true,
                  headers: csrfToken ? {[CSRF_HEADER]: csrfToken} : {},
                }
            ).finally(() => {
              refreshPromise = null;
            });
          }
          await refreshPromise;
          return axiosInstance(config);
        } catch (refreshError) {
          return Promise.reject(refreshError);
        }
      }

      return Promise.reject(error);
    }
);

export default axiosInstance;
